import {combineReducers} from "redux";

//TODO import { ConnectedRouter, routerReducer, routerMiddleware, push } from 'react-router-redux'

import {reducer as formReducer} from 'redux-form'

import auth from './auth';
import transactions from './transactionReducers';
import modal from './modal';
import account from './account';

const appReducer = combineReducers({
  auth,
  transactions,
  modal,
  account,
  form: formReducer
});

const rootReducer = (state, action) => {

  //TODO: empty out the client store upon logout - uncomment once logout sequence is finalized
  /* if (action.type === 'LOGOUT_SUCCESS') {
    return appReducer(undefined, action)
  } */

  return appReducer(state, action)
}

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js